import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PaymentApi} from 'src/app/api/payment/payment.api.class';
import {environment} from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AnalyticsService } from '../analytics/analytics.service';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {
    constructor(
        private paymentApi: PaymentApi,
        private http: HttpClient,
        private router: Router,
        private analyticsService: AnalyticsService
    ) {}

    returnToMerchant(sessionToken, userCancelled?): Observable<any> {
      if (userCancelled) {
        return this.paymentApi.returnToMerchant(sessionToken, userCancelled);
      } else {
        return this.paymentApi.returnToMerchant(sessionToken);
      }
    }

    cancelTransactionOnUnload(sessionToken: string): void {
      // !!! IMPORTANT: Verify this API endpoint path and query parameter !!!
      const baseApiUrl = environment.production ? "/channel-virtual/api/v1" + '/response' : environment.baseUrl + '/response';
      // Construct the URL with a query parameter
      const url = `${baseApiUrl}/postback/${sessionToken}?userCancelled=true`;

      console.log('Attempting sendBeacon with URL:', url); // Log the exact URL

      if (navigator.sendBeacon) {
        try {
          const sent = navigator.sendBeacon(url);
          if (!sent) {
            console.error('navigator.sendBeacon failed to queue the request for unload cancellation.');
          }
        } catch (error) {
          console.error('Error calling navigator.sendBeacon:', error);
        }
      } else {
        console.error('navigator.sendBeacon not supported for unload cancellation.');
      }
    }

    selectPaymentMethod(paymentMethod: string, sessionToken: string): void {
      // Track the payment method selection
      this.analyticsService.trackPaymentMethodSelection(sessionToken, paymentMethod).subscribe();
    }

    processPaymentResult(result: any, paymentMethod: string): void {
      const sessionToken = sessionStorage.getItem('sessionToken');
      const success = result && result.success;
      
      if (sessionToken) {
        this.analyticsService.trackPaymentCompletion(sessionToken, paymentMethod, success).subscribe();
      }
    }
}
